import { render } from "./AgentsView.vue?vue&type=template&id=1a8a0246"
import script from "./AgentsView.vue?vue&type=script&lang=js"
export * from "./AgentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__